export default function CheckIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z"
        fill="#5BA600"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 14.1212V11.9998L9.12131 11.9998L12.6457 15.5242L18.9189 9L21 9L21 11.164L13.7479 18.7062L12.6877 19.8089L11.606 18.7272L7 14.1212Z"
        fill="white"
      />
    </svg>
  );
}
